import { useCallback, useState } from 'react';
import Services from 'services/network';
import { INoteCode } from 'common/components/PersonProfile/interfaces';

interface IFetchingNoteCodesState {
  fetchNoteCodes: (search: string) => void;
  clearNoteCodes: () => void;
  isLoading: boolean;
  error?: Error;
  noteCodes: INoteCode[];
}

const useSearchNoteCodes = (): IFetchingNoteCodesState => {
  const [noteCodes, setNoteCodes] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetchNoteCodes = useCallback(
    (search: string) => {
      (async () => {
        try {
          setError(null);
          setIsLoading(true);

          const { data } = await Services.DictionaryLists.searchNoteCodesDictionary(search);

          setNoteCodes(data);
        } catch (e) {
          setError(e);
        } finally {
          setIsLoading(false);
        }
      })();
    },
    [setNoteCodes, setError, setIsLoading],
  );

  const clearNoteCodes = () => {
    setNoteCodes([]);
  };

  return { fetchNoteCodes, isLoading, error: error || undefined, noteCodes, clearNoteCodes };
};

export default useSearchNoteCodes;
